import React, { useState } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Col, Row, Button, message,
} from 'antd';
import HeroSliderForm from '../../../../components/HeroSliderForm/HeroSliderForm';
import heroSlidesApi from '../../../../utils/api/hero/PostHeros';
import './HeroToolContainer.less';

const HeroToolContainer = (props) => {
  const { token } = props;

  const [heroElements, setHeroElements] = useState([]);

  const handleSetHeroElement = (data) => {
    let tmpData = [];
    const { edit, campaign } = data;
    if (edit) {
      tmpData = heroElements.map((e) => {
        if (e.campaign === campaign) return data;
        return e;
      });
    } else tmpData = [].concat(heroElements, data);
    setHeroElements(tmpData);
  };

  const handleDeleteAction = (campaign) => {
    const data = heroElements.filter((e) => e.campaign !== campaign);
    setHeroElements(data);
  };

  const renderHeroSliderForms = () => (
    <div>
      <HeroSliderForm
        key={new Date().getTime()}
        action={handleSetHeroElement}
        data={false}
        token={token}
      />
      {heroElements.map((e) => (
        <HeroSliderForm
          key={e.campaign}
          action={handleSetHeroElement}
          deleteAction={handleDeleteAction}
          isEdit
          token={token}
          data={e}
        />
      ))}
    </div>
  );

  const postData = async () => {
    try {
      const payload = heroElements.map((e) => ({
        campaign: e.campaign,
        click_out: e.click_out,
        images: {
          img_l: e.img_l,
          img_m: e.img_m,
          img_s: e.img_s,
        },
      }));
      const response = await heroSlidesApi.postHeros(payload);
      if (response) message.success('Heros Actualizados!');
    } catch (err) {
      message.error(err);
    }
  };

  return (
    <div className="hero-tool-main-container">
      <Col span={16}>
        <h2 className="form-title">Hero Sliders</h2>
        <Row>{renderHeroSliderForms()}</Row>
      </Col>
      <Col span={7}>
        <div className="hero-tool-offer-sider">
          <div className="hero-tool-section-box">
            <h2>Publicar </h2>
          </div>
          <div className="hero-tool-section-box">
            <Button
              disabled={heroElements.length === 0}
              className="publish-button publish-green-button"
              onClick={() => postData()}
            >
              Guardar Heros
            </Button>
          </div>
        </div>
      </Col>
    </div>
  );
};

HeroToolContainer.propTypes = {
  token: PropTypes.string.isRequired,
};

export default withRouter(HeroToolContainer);
